import { useQuery } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';
import { useState } from 'react';

const GET_PURPOSE_CONFIGS_QUERY = gql`
  query purposeconfigs($tenantId: ObjectId!) {
    purposeconfigs(
      query: { tenant: { _id: $tenantId }, purpose: "Client Transfer" }
    ) {
      _id
      fields
      config
      active
      tenant {
        _id
        name
      }
    }
  }
`;

export default function useAllPurposeConfigsFromTenant(tenantId) {
  const shouldSkip = tenantId === null;
  const { loading, error, data } = useQuery(GET_PURPOSE_CONFIGS_QUERY, {
    variables: { tenantId },
    fetchPolicy: 'no-cache',
    skip: shouldSkip,
  });

  const purposeConfigs = data ? data.purposeconfigs : undefined;

  return {
    loading,
    error,
    purposeConfigs,
  };
}
